import React from 'react';
import WelcomeLayout from './welcome-layout';
import { useNavigation } from 'hooks/index';
import { useProfile } from 'providers/profile.provider';

const Welcome: React.FC = () => {
    const { goToBizcapitalSite } = useNavigation();
    const { loanApplicationUtmSource } = useProfile();

    window.onbeforeunload = () => {
        return null;
    };

    return (
        <WelcomeLayout
            onOk={goToBizcapitalSite}
            utmSource={loanApplicationUtmSource}
        />
    );
};

export default Welcome;
